var Feature;
(function(Feature2) {
  Feature2["CreditCardElements"] = "CreditCardElements";
  Feature2["CvvCardElement"] = "CvvCardElement";
  Feature2["DigitalWallets"] = "DigitalWallets";
  Feature2["SingleLineCardElement"] = "SingleLineCardElement";
})(Feature || (Feature = {}));
const log = (...data) => console.log("%c Olo Pay ", "background: #25B3E2; color: #ffffff", ...data);
const warn = (...data) => console.warn("%c Olo Pay ", "background: #F3A966; color: #ffffff", ...data);
const throwError = (message2) => {
  if (message2) {
    throw new Error(`Olo Pay Error: ${message2}`);
  }
};
const error = (...data) => {
  console.error("%c Olo Pay Error ", "background: #FF2A53; color: #ffffff", ...data);
};
const message = {
  log,
  warn,
  error,
  throw: throwError
};
var pure$1 = {};
Object.defineProperty(pure$1, "__esModule", { value: true });
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
var V3_URL$1 = "https://js.stripe.com/v3";
var V3_URL_REGEX$1 = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE$1 = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var findScript$1 = function findScript() {
  var scripts = document.querySelectorAll('script[src^="'.concat(V3_URL$1, '"]'));
  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];
    if (!V3_URL_REGEX$1.test(script.src)) {
      continue;
    }
    return script;
  }
  return null;
};
var injectScript$1 = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
  var script = document.createElement("script");
  script.src = "".concat(V3_URL$1).concat(queryString);
  var headOrBody = document.head || document.body;
  if (!headOrBody) {
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  }
  headOrBody.appendChild(script);
  return script;
};
var registerWrapper = function registerWrapper2(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }
  stripe._registerWrapper({
    name: "stripe-js",
    version: "1.54.0",
    startTime
  });
};
var stripePromise$2 = null;
var loadScript$1 = function loadScript(params) {
  if (stripePromise$2 !== null) {
    return stripePromise$2;
  }
  stripePromise$2 = new Promise(function(resolve, reject) {
    if (typeof window === "undefined" || typeof document === "undefined") {
      resolve(null);
      return;
    }
    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE$1);
    }
    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }
    try {
      var script = findScript$1();
      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE$1);
      } else if (!script) {
        script = injectScript$1(params);
      }
      script.addEventListener("load", function() {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error("Stripe.js not available"));
        }
      });
      script.addEventListener("error", function() {
        reject(new Error("Failed to load Stripe.js"));
      });
    } catch (error2) {
      reject(error2);
      return;
    }
  });
  return stripePromise$2;
};
var initStripe = function initStripe2(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }
  var stripe = maybeStripe.apply(void 0, args);
  registerWrapper(stripe, startTime);
  return stripe;
};
var validateLoadParams = function validateLoadParams2(params) {
  var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");
  if (params === null || _typeof(params) !== "object") {
    throw new Error(errorMessage);
  }
  if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === "boolean") {
    return params;
  }
  throw new Error(errorMessage);
};
var loadParams;
var loadStripeCalled = false;
var loadStripe = function loadStripe2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  loadStripeCalled = true;
  var startTime = Date.now();
  return loadScript$1(loadParams).then(function(maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};
loadStripe.setLoadParameters = function(params) {
  if (loadStripeCalled && loadParams) {
    var validatedParams = validateLoadParams(params);
    var parameterKeys = Object.keys(validatedParams);
    var sameParameters = parameterKeys.reduce(function(previousValue, currentValue) {
      var _loadParams;
      return previousValue && params[currentValue] === ((_loadParams = loadParams) === null || _loadParams === void 0 ? void 0 : _loadParams[currentValue]);
    }, true);
    if (sameParameters) {
      return;
    }
  }
  if (loadStripeCalled) {
    throw new Error("You cannot change load parameters after calling loadStripe");
  }
  loadParams = validateLoadParams(params);
};
pure$1.loadStripe = loadStripe;
var pure = pure$1;
const loadWithoutSideEffect = pure.loadStripe;
var URL;
(function(URL2) {
  URL2["development"] = "https://static.olocdn.net/web-client/olo-pay/keys/dev.json";
  URL2["production"] = "https://static.olocdn.net/web-client/olo-pay/keys/prod.json";
})(URL || (URL = {}));
async function initializeOloPay() {
  try {
    await Promise.resolve().then(() => stripe_esm);
  } catch (e) {
    if (e instanceof Error) {
      message.error(`${e.message}`);
      message.error(`${e.stack}`);
      console.error("%c Olo Pay Error ", "background: #FF2A53; color: #ffffff", `${e.message}`);
      console.error("%c Olo Pay Error Stack Trace ", "background: #FFA500; color: #ffffff", `${e.stack}`);
    }
  }
}
async function setupStripe(feature, key) {
  let stripe = null;
  let imported = false;
  try {
    if (stripe === null) {
      imported = true;
      stripe = await loadWithoutSideEffect(key);
    }
    if (stripe === null) {
      message.error(`Failed to load Stripe. Tried import = ${imported}`);
      throw new Error();
    }
    return stripe;
  } catch (e) {
    if (e instanceof Error) {
      message.error(`${feature}: ${e.message}`);
      message.error(`${feature}: ${e.stack}`);
      console.error("%c Olo Pay Error ", "background: #FF2A53; color: #ffffff", `${feature}: ${e.message}`);
      console.error("%c Olo Pay Error Stack Trace ", "background: #FFA500; color: #ffffff", `${feature}: ${e.stack}`);
    }
  }
}
async function fetchKey(url, env) {
  message.log(`Fetching key for ${env}`);
  try {
    const response = await fetch(url);
    const json = await response.json();
    return json.key.trim() || "";
  } catch (e) {
    if (e instanceof Error) {
      message.error(`Failed to fetch key ${JSON.stringify(e)}`);
    }
    return "";
  }
}
async function configureStripe(feature, env) {
  message.log(`Setting up Stripe for ${env}`);
  const url = /\bproduction\b/i.test(env) ? URL.production : URL.development;
  const key = await fetchKey(url, env);
  const stripe = await setupStripe(feature, key).catch((err) => message.error(err));
  if (!stripe) {
    message.error(`${feature}: Failed to access Olo Pay`);
    return void 0;
  }
  return stripe;
}
const defaultBase = {
  color: "inherit",
  backgroundColor: "inherit",
  fontFamily: "inherit",
  fontSize: "1.8rem",
  fontSmoothing: "inherit",
  fontStyle: "inherit",
  fontVariant: "inherit",
  fontWeight: "inherit",
  iconColor: "#25B3E2",
  lineHeight: "inherit",
  letterSpacing: "inherit",
  textAlign: "inherit",
  textDecoration: "inherit",
  textShadow: "inherit",
  textTransform: "inherit"
};
const defaultPseudos = {
  ":hover": defaultBase,
  ":focus": defaultBase,
  "::placeholder": defaultBase,
  "::selection": defaultBase,
  ":-webkit-autofill": defaultBase,
  ":disabled": defaultBase,
  "::-ms-clear": { ...defaultBase, display: "string" }
};
const defaultStyles = {
  ...defaultBase,
  ...defaultPseudos
};
const defaultStyleObject = {
  base: { ...defaultStyles },
  complete: { ...defaultStyles },
  empty: { ...defaultStyles },
  invalid: { ...defaultStyles }
};
class CreditCardElements {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  constructor(environment = "development") {
    Object.defineProperty(this, "environment", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: environment
    });
    Object.defineProperty(this, "stripe", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "defaultMountTargets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        number: "[data-olo-pay-card-number]",
        expiry: "[data-olo-pay-card-expiry]",
        cvc: "[data-olo-pay-card-cvc]",
        cvv: "[data-olo-pay-card-cvv]"
      }
    });
    Object.defineProperty(this, "defaultOptions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        classes: {
          base: "olo-pay",
          complete: "olo-pay--complete",
          empty: "olo-pay--empty",
          focus: "olo-pay--focus",
          invalid: "olo-pay--invalid",
          webkitAutofill: "olo-pay--webkit-autofill"
        }
      }
    });
    Object.defineProperty(this, "defaultPlaceholders", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        number: "Card number",
        expiry: "Card expiry",
        cvc: "Card cvv",
        cvv: "Card cvv"
      }
    });
    Object.defineProperty(this, "cardNumber", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "cardExpiry", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "cardCvc", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "cardCvv", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "elements", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  // ===========================================================================
  // Methods
  // ===========================================================================
  /**
   * Appends a credit card field to a passed element or selector of a DOM element.
   *
   * Defaults:
   * - Credit card number: `data-olo-pay-card-number`
   * - Credit card expiration date: `data-olo-pay-card-expiry`
   * - Credit card cvc: `data-olo-pay-card-cvc` [Deprecated]
   * - Credit card cvv: `data-olo-pay-card-cvv`
   *
   * Note: all three fields are required for a valid credit card submission.
   *
   * @param cardOptions Options object containing information for:
   * `cardElementOptions`, `elementsOptions`, `mountTargets`, and `placeholders`.
   */
  async create(cardOptions) {
    var _a, _b;
    this.stripe = await configureStripe(Feature.CreditCardElements, this.environment);
    if (!this.stripe)
      return;
    const elements = this.stripe.elements((cardOptions == null ? void 0 : cardOptions.elementsOptions) || {});
    const options = {
      ...this.defaultOptions,
      ...cardOptions == null ? void 0 : cardOptions.cardElementOptions
    };
    const placeholders = (cardOptions == null ? void 0 : cardOptions.placeholders) || this.defaultPlaceholders;
    const targets = (cardOptions == null ? void 0 : cardOptions.mountTargets) || this.defaultMountTargets;
    if (cardOptions && ((_a = cardOptions == null ? void 0 : cardOptions.mountTargets) == null ? void 0 : _a.cvv)) {
      delete targets.cvc;
    } else if (cardOptions && ((_b = cardOptions == null ? void 0 : cardOptions.mountTargets) == null ? void 0 : _b.cvc) || !(cardOptions == null ? void 0 : cardOptions.mountTargets)) {
      delete targets.cvv;
    }
    const cardNumber = elements.create("cardNumber", {
      ...options,
      placeholder: placeholders.number
    });
    const cardExpiry = elements.create("cardExpiry", {
      ...options,
      placeholder: placeholders.expiry
    });
    let cardCvc;
    let cardCvv;
    if (targets.cvc) {
      message.warn('Deprecation: Use the "cvv" key for mountTargets and placeholder objects. CVC will be deprecated in the next major version');
      cardCvc = elements.create("cardCvc", {
        ...options,
        placeholder: placeholders.cvc
      });
    }
    if (targets.cvv) {
      cardCvv = elements.create("cardCvc", {
        ...options,
        placeholder: placeholders.cvv
      });
    }
    try {
      cardNumber.mount(targets.number);
      cardExpiry.mount(targets.expiry);
      if (cardCvc !== void 0 && targets.cvc) {
        cardCvc.mount(targets.cvc);
      }
      if (cardCvv !== void 0 && targets.cvv) {
        cardCvv.mount(targets.cvv);
      }
    } catch (e) {
      message.error(`${Feature.CreditCardElements}:
        Unable to mount Olo Pay elements to their DOM targets
        Please ensure valid selectors or elements are passed to \`create\``);
      return;
    }
    this.cardNumber = elements.getElement("cardNumber") || void 0;
    this.cardExpiry = elements.getElement("cardExpiry") || void 0;
    if (cardCvc !== void 0 && targets.cvc) {
      this.cardCvc = elements.getElement("cardCvc") || void 0;
    }
    if (cardCvv !== void 0 && targets.cvv) {
      this.cardCvv = elements.getElement("cardCvc") || void 0;
    }
    if (!this.cardNumber)
      return message.error("Number input not mounted properly");
    if (!this.cardExpiry)
      return message.error("Expiry input not mounted properly");
    if (!this.cardCvc && !this.cardCvv)
      return message.error("cvv input not mounted properly");
    this.elements = [this.cardNumber, this.cardExpiry, this.cardCvv || this.cardCvc];
  }
  /**
   * Creates a payment method using card details on the form and
   * billing details (if passed).
   *
   * @param billingDetails Address, email, name, and phone.
   */
  async createPaymentMethod(billingDetails) {
    if (!this.stripe || !this.cardNumber) {
      message.error(`Failed to create a payment method due to missing: ${this.stripe ? "cardNumber element" : "Olo Pay connection. Call `create` first"}`);
      return;
    }
    const paymentMethod = await this.stripe.createPaymentMethod({
      type: "card",
      card: this.cardNumber,
      billing_details: billingDetails
    });
    return paymentMethod;
  }
  /**
   * Applies a style object to the credit card elements.
   *
   * @param style Style object.
   */
  applyStyles(style = defaultStyleObject) {
    var _a, _b, _c, _d;
    (_a = this.cardNumber) == null ? void 0 : _a.update({ style });
    (_b = this.cardExpiry) == null ? void 0 : _b.update({ style });
    if (this.cardCvc !== void 0) {
      (_c = this.cardCvc) == null ? void 0 : _c.update({ style });
    }
    if (this.cardCvv !== void 0) {
      (_d = this.cardCvv) == null ? void 0 : _d.update({ style });
    }
  }
  /**
   * Clear all credit card field values.
   */
  clear() {
    var _a, _b, _c, _d;
    (_a = this.cardNumber) == null ? void 0 : _a.clear();
    (_b = this.cardExpiry) == null ? void 0 : _b.clear();
    if (this.cardCvc !== void 0) {
      (_c = this.cardCvc) == null ? void 0 : _c.clear();
    }
    if (this.cardCvv !== void 0) {
      (_d = this.cardCvv) == null ? void 0 : _d.clear();
    }
  }
  /**
   * Removes credit card elements from the DOM and destroys them.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  destroy() {
    var _a, _b, _c, _d;
    (_a = this.cardNumber) == null ? void 0 : _a.destroy();
    (_b = this.cardExpiry) == null ? void 0 : _b.destroy();
    if (this.cardCvc !== void 0) {
      (_c = this.cardCvc) == null ? void 0 : _c.destroy();
    }
    if (this.cardCvv !== void 0) {
      (_d = this.cardCvv) == null ? void 0 : _d.destroy();
    }
    this.elements = void 0;
  }
  /**
   * Mounts credit card elements to the DOM.
   * Call `unmount` to remove them from the DOM.
   *
   * @param mountTargets Object containing selector or element targets.
   */
  mount(mountTargets = this.defaultMountTargets) {
    var _a, _b, _c, _d;
    (_a = this.cardNumber) == null ? void 0 : _a.mount(mountTargets.number);
    (_b = this.cardExpiry) == null ? void 0 : _b.mount(mountTargets.expiry);
    if (this.cardCvc !== void 0) {
      (_c = this.cardCvc) == null ? void 0 : _c.mount(mountTargets.cvc);
    }
    if (this.cardCvv !== void 0) {
      (_d = this.cardCvv) == null ? void 0 : _d.mount(mountTargets.cvv);
    }
  }
  /**
   * Unmounts credit card elements from the DOM.
   * Call `mount` to re-attach them to the DOM.
   */
  unmount() {
    var _a, _b, _c, _d;
    (_a = this.cardNumber) == null ? void 0 : _a.unmount();
    (_b = this.cardExpiry) == null ? void 0 : _b.unmount();
    if (this.cardCvc !== void 0) {
      (_c = this.cardCvc) == null ? void 0 : _c.unmount();
    }
    if (this.cardCvv !== void 0) {
      (_d = this.cardCvv) == null ? void 0 : _d.unmount();
    }
  }
  /**
   * Updates the options the credit card elements were initialized with.
   * Updates are merged into the existing configuration.
   *
   * @param newOptions
   */
  update(newOptions = this.defaultOptions) {
    var _a, _b, _c, _d;
    (_a = this.cardNumber) == null ? void 0 : _a.update(newOptions);
    (_b = this.cardExpiry) == null ? void 0 : _b.update(newOptions);
    if (this.cardCvc !== void 0) {
      (_c = this.cardCvc) == null ? void 0 : _c.update(newOptions);
    }
    if (this.cardCvv !== void 0) {
      (_d = this.cardCvv) == null ? void 0 : _d.update(newOptions);
    }
  }
}
class CvvElement {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  constructor(environment = "development") {
    Object.defineProperty(this, "environment", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: environment
    });
    Object.defineProperty(this, "stripe", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "defaultMountTarget", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "[data-olo-pay-cvv]"
    });
    Object.defineProperty(this, "defaultOptions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        classes: {
          base: "cvv",
          complete: "cvv--complete",
          empty: "cvv--empty",
          focus: "cvv--focus",
          invalid: "cvv--invalid",
          webkitAutofill: "cvv--webkit-autofill"
        }
      }
    });
    Object.defineProperty(this, "element", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  // ===========================================================================
  // Methods
  // ===========================================================================
  /**
   * Appends a cvv field to a passed element or selector of a DOM element.
   *
   * Defaults:
   * - CVV: `data-olo-pay-cvv`
   *
   * @param cvvOptions Options object containing information for:
   * `cvvElementOptions`, `elementsOptions`, `mountTarget`.
   */
  async create(cvvOptions) {
    this.stripe = await configureStripe(Feature.CvvCardElement, this.environment);
    if (!this.stripe)
      return;
    const elements = this.stripe.elements((cvvOptions == null ? void 0 : cvvOptions.elementsOptions) || {});
    const options = {
      ...this.defaultOptions,
      ...cvvOptions == null ? void 0 : cvvOptions.cvvElementOptions
    };
    const cvv = elements.create("cardCvc", {
      ...options
    });
    const target = (cvvOptions == null ? void 0 : cvvOptions.mountTarget) || this.defaultMountTarget;
    try {
      cvv.mount(target);
    } catch (e) {
      message.error(`${Feature.CvvCardElement}:
              Unable to mount Olo Pay cvv element to its DOM target
              Please ensure valid selectors or elements are passed to \`create\``);
      return;
    }
    this.element = elements.getElement("cardCvc") || void 0;
    if (!this.element)
      return message.error("cvv element not mounted properly");
    return;
  }
  /**
   * Creates a cvv token for cvv revalidation
   */
  async createCvvToken() {
    if (!this.stripe || !this.element) {
      message.error(`Failed to create a cvv revalidation token due to missing: ${this.stripe ? "cvv element" : "Olo Pay connection. Call `create` first"}`);
      return;
    }
    const token = await this.stripe.createToken("cvc_update", this.element);
    return token;
  }
  /**
   * Applies a style object to the element.
   *
   * @param style Style object.
   */
  applyStyles(style = defaultStyleObject) {
    var _a;
    (_a = this.element) == null ? void 0 : _a.update({ style });
  }
  /**
   * Clear all field values.
   */
  clear() {
    var _a;
    (_a = this.element) == null ? void 0 : _a.clear();
  }
  /**
   * Removes the element from the DOM and destroys it.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  destroy() {
    var _a;
    (_a = this.element) == null ? void 0 : _a.destroy();
    this.element = void 0;
  }
  /**
   * Mounts the element to the DOM.
   * Call `unmount` to remove it from the DOM.
   *
   * @param mountTarget Object containing selector or element target.
   */
  mount(mountTarget = this.defaultMountTarget) {
    var _a;
    (_a = this.element) == null ? void 0 : _a.mount(mountTarget);
  }
  /**
   * Unmounts the element from the DOM.
   * Call `mount` to re-attach it to the DOM.
   */
  unmount() {
    var _a;
    (_a = this.element) == null ? void 0 : _a.unmount();
  }
  /**
   * Updates the options that the element was initialized with.
   * Updates are merged into the existing configuration.
   *
   * @param newOptions
   */
  update(newOptions = this.defaultOptions) {
    var _a;
    (_a = this.element) == null ? void 0 : _a.update(newOptions);
  }
}
const isElement = (item) => item.nodeType === 1 && item.matches("*");
function find(target) {
  if (isElement(target)) {
    const element = target;
    return element.isConnected ? element : null;
  }
  try {
    return document.querySelector(target);
  } catch (error2) {
    message.error(`No element marked with ${target} found`);
    return null;
  }
}
const TEST_PAYMENT_METHOD = {
  paymentMethod: {
    id: "pm_visa_test_mode",
    object: "payment_method",
    billing_details: {
      address: {
        city: "New York",
        country: "US",
        line1: "One World Trade Center",
        line2: null,
        postal_code: "10006",
        state: "NY"
      },
      email: "olopaytest@test.com",
      name: "Test Mode",
      phone: "4444444444"
    },
    card: {
      brand: "visa",
      checks: {
        address_line1_check: null,
        address_postal_code_check: null,
        cvc_check: null
      },
      country: "US",
      exp_month: 12,
      exp_year: 2031,
      funding: "credit",
      generated_from: null,
      last4: "1234",
      networks: {
        available: ["visa"],
        preferred: null
      },
      three_d_secure_usage: {
        supported: true
      },
      wallet: {
        dynamic_last4: "1234",
        google_pay: {},
        type: "google_pay"
      }
    },
    created: 1628283848,
    customer: null,
    livemode: false,
    type: "card"
  }
};
class DigitalWallets {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  constructor(environment = "development") {
    Object.defineProperty(this, "environment", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: environment
    });
    Object.defineProperty(this, "stripe", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "digitalWalletsOptions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "paymentEvent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "paymentRequest", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "defaultPaymentRequestOptions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        currency: "usd",
        total: {
          label: "test",
          amount: 0
        },
        requestPayerName: true
      }
    });
    Object.defineProperty(this, "canMakePayment", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "paymentButton", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  // ===========================================================================
  // Methods
  // ===========================================================================
  /**
   * Initializes a digital wallet's payment request so that a `DigitalWallets` button can be created.
   *
   * @param options Digital wallets options containing style and payment request options.
   * @example
   * HTML
   * <div data-olo-pay-payment-button></div>
   *
   * @example
   * JS
   * const digitalWallets = new DigitalWallets();
   * await digitalWallets.initialize(options);
   *
   * // Will return an object of { applePay: false, googlePay: false }
   * const canMakePayment = digitalWallets.canMakePayment;
   */
  async initialize(options) {
    if (!this.stripe) {
      this.stripe = await configureStripe(Feature.DigitalWallets, this.environment);
    }
    if (!this.stripe)
      return;
    if (!options) {
      message.error("No digital wallets options provided");
      return;
    }
    this.digitalWalletsOptions = options;
    if (this.paymentRequest && !this.paymentRequest.isShowing()) {
      const { currency, total, displayItems, shippingOptions } = this.digitalWalletsOptions.options;
      this.updatePaymentDetails({
        currency,
        total,
        displayItems,
        shippingOptions
      });
      this.canMakePayment = await this.paymentRequest.canMakePayment();
      return;
    }
    const paymentRequest = this.stripe.paymentRequest(this.digitalWalletsOptions.options);
    this.canMakePayment = await paymentRequest.canMakePayment();
    this.paymentRequest = paymentRequest;
  }
  /**
   * Appends a `Stripe Elements` Payment Request Button to an element marked with a matching `data-olo-pay-payment-button` attribute.
   * @param callback Function to execute after the payment is submitted in the digital wallets payment sheet.
   *
   * @example
   * HTML
   * <div data-olo-pay-payment-button></div>
   *
   * @example
   * JS
   * const digitalWallets = new DigitalWallets();
   * await digitalWallets.initialize(options);
   * digitalWallets.mountButton(callback);
   */
  mountButton(callback, target) {
    if (!this.digitalWalletsOptions || !this.paymentRequest || !this.stripe) {
      message.error("Digital Wallets not initialized properly.");
      return;
    }
    const paymentRequest = this.paymentRequest;
    paymentRequest.on("paymentmethod", (ev) => {
      this.paymentEvent = ev;
      callback(ev.paymentMethod);
    });
    const buttonSlot = find(target || "[data-olo-pay-payment-button]");
    if (!buttonSlot)
      return;
    const { classes, style } = this.digitalWalletsOptions;
    const elements = this.stripe.elements();
    const button = elements.create("paymentRequestButton", {
      paymentRequest,
      // Add optional classes object if it exists
      ...classes ? classes : {},
      // Add optional style object if it exists
      ...style ? { style: { paymentRequestButton: { ...style } } } : {}
    });
    if (buttonSlot && this.canMakePayment) {
      button.mount("[data-olo-pay-payment-button]");
    } else {
      buttonSlot.style.display = "none";
    }
    if (this.environment === "test") {
      message.log("Digital Wallets is running in test mode.");
      button.on("click", (event) => {
        event.preventDefault();
        window.PaymentRequest = paymentRequest;
        window.PaymentRequest.emit("paymentmethod", TEST_PAYMENT_METHOD);
      });
    }
    this.paymentButton = button;
  }
  /**
   * Initiates a payment by showing the Google Pay or Apple Pay payment sheet.
   * This can be triggered when using a custom payment button,
   * or in scenarios where preventing the default 'click' event behavior is necessary
   * (i.e. proper form validation prior to initiating the payment).
   *
   * @example
   * const digitalWallets = new DigitalWallets();
   * await digitalWallets.initialize(options);
   *
   * digitalWallets.paymentButton.on('click', (event) => {
   *  event.preventDefault();
   *
   *  // Launch payment sheet if form is valid
   *  if (formIsValid) {
   *    dw.initiatePayment();
   *  }
   * });
   */
  initiatePayment() {
    var _a;
    if (this.canMakePayment) {
      (_a = this.paymentRequest) == null ? void 0 : _a.show();
    }
  }
  /**
   * Determines which digital wallets are available in the current browser context.
   *
   * @example
   * const canRenderButton = await digitalWallets.canRenderButton();
   * if (canRenderButton && (canRenderButton.applePay || canRenderButton.googlePay)) {
   *  // Do something
   * }
   */
  async canRenderButton(country = "US") {
    var _a;
    this.stripe = await configureStripe(Feature.DigitalWallets, this.environment);
    if (!this.stripe)
      return null;
    this.paymentRequest = (_a = this.stripe) == null ? void 0 : _a.paymentRequest({
      ...this.defaultPaymentRequestOptions,
      country
    });
    this.canMakePayment = await this.paymentRequest.canMakePayment();
    return this.canMakePayment;
  }
  /**
   * Updates payment details to be reflected on the payment sheet
   */
  updatePaymentDetails(options) {
    if (!this.paymentRequest)
      return;
    this.paymentRequest.update(options);
  }
  /**
   * Completes the pending payment event to close the active payment sheet
   */
  completePaymentEvent() {
    var _a;
    (_a = this.paymentEvent) == null ? void 0 : _a.complete("success");
  }
  /**
   * Fails the pending payment event
   */
  failPaymentEvent() {
    var _a;
    (_a = this.paymentEvent) == null ? void 0 : _a.complete("fail");
  }
  /**
   * Removes the element from the DOM and destroys it.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  destroy() {
    var _a;
    (_a = this.paymentButton) == null ? void 0 : _a.destroy();
  }
  /**
   * Unmounts the element from the DOM. Call element.mount to re-attach it to the DOM.
   */
  unmount() {
    var _a;
    (_a = this.paymentButton) == null ? void 0 : _a.unmount();
  }
}
class SingleLineCardElement {
  // ===========================================================================
  // Constructor
  // ===========================================================================
  constructor(environment = "development") {
    Object.defineProperty(this, "environment", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: environment
    });
    Object.defineProperty(this, "stripe", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "defaultMountTarget", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "[data-olo-pay-card-single-line]"
    });
    Object.defineProperty(this, "defaultOptions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        classes: {
          base: "olo-pay",
          complete: "olo-pay--complete",
          empty: "olo-pay--empty",
          focus: "olo-pay--focus",
          invalid: "olo-pay--invalid",
          webkitAutofill: "olo-pay--webkit-autofill"
        }
      }
    });
    Object.defineProperty(this, "element", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  // ===========================================================================
  // Methods
  // ===========================================================================
  /**
   * Appends a single-line credit card field to a passed element or selector of a DOM element.
   *
   * If no value for `mountTarget` is passed in, the default mount target is `data-olo-pay-card-single-line`.
   *
   * @param cardOptions Options object containing information for:
   * `cardElementOptions`, `elementsOptions`, `mountTarget`.
   */
  async create(cardOptions) {
    this.stripe = await configureStripe(Feature.SingleLineCardElement, this.environment);
    if (!this.stripe)
      return;
    const elements = this.stripe.elements((cardOptions == null ? void 0 : cardOptions.elementsOptions) || {});
    const options = {
      ...this.defaultOptions,
      ...cardOptions == null ? void 0 : cardOptions.cardElementOptions
    };
    const card = elements.create("card", {
      ...options
    });
    const target = (cardOptions == null ? void 0 : cardOptions.mountTarget) || this.defaultMountTarget;
    try {
      card.mount(target);
    } catch (e) {
      message.error(`${Feature.SingleLineCardElement}:
          Unable to mount Olo Pay single-line card element to its DOM target
          Please ensure valid selectors or elements are passed to \`create\``);
      return;
    }
    this.element = elements.getElement("card") || void 0;
    if (!this.element)
      return message.error("Single-line card element not mounted properly");
    return;
  }
  /**
   * Creates a payment method using card details on the form and
   * billing details (if passed).
   *
   * @param billingDetails Address, email, name, and phone.
   */
  async createPaymentMethod(billingDetails) {
    if (!this.stripe || !this.element) {
      message.error(`Failed to create a payment method due to missing: ${this.stripe ? "singleLineCard element" : "Olo Pay connection. Call `create` first"}`);
      return;
    }
    const paymentMethod = await this.stripe.createPaymentMethod({
      type: "card",
      card: this.element,
      billing_details: billingDetails
    });
    return paymentMethod;
  }
  /**
   * Applies a style object to the element.
   *
   * @param style Style object.
   */
  applyStyles(style = defaultStyleObject) {
    var _a;
    (_a = this.element) == null ? void 0 : _a.update({ style });
  }
  /**
   * Clear all credit card field values.
   */
  clear() {
    var _a;
    (_a = this.element) == null ? void 0 : _a.clear();
  }
  /**
   * Removes the element from the DOM and destroys it.
   * A destroyed element can not be re-activated or re-mounted to the DOM.
   */
  destroy() {
    var _a;
    (_a = this.element) == null ? void 0 : _a.destroy();
    this.element = void 0;
  }
  /**
   * Mounts the element to the DOM.
   * Call `unmount` to remove it from the DOM.
   *
   * @param mountTarget Object containing selector or element target.
   */
  mount(mountTarget = this.defaultMountTarget) {
    var _a;
    (_a = this.element) == null ? void 0 : _a.mount(mountTarget);
  }
  /**
   * Unmounts the element from the DOM.
   * Call `mount` to re-attach it to the DOM.
   */
  unmount() {
    var _a;
    (_a = this.element) == null ? void 0 : _a.unmount();
  }
  /**
   * Updates the options that the element was initialized with.
   * Updates are merged into the existing configuration.
   *
   * @param newOptions
   */
  update(newOptions = this.defaultOptions) {
    var _a;
    (_a = this.element) == null ? void 0 : _a.update(newOptions);
  }
}
var V3_URL = "https://js.stripe.com/v3";
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var findScript2 = function findScript3() {
  var scripts = document.querySelectorAll('script[src^="'.concat(V3_URL, '"]'));
  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];
    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }
    return script;
  }
  return null;
};
var injectScript2 = function injectScript3(params) {
  var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
  var script = document.createElement("script");
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;
  if (!headOrBody) {
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  }
  headOrBody.appendChild(script);
  return script;
};
var stripePromise = null;
var loadScript2 = function loadScript3(params) {
  if (stripePromise !== null) {
    return stripePromise;
  }
  stripePromise = new Promise(function(resolve, reject) {
    if (typeof window === "undefined" || typeof document === "undefined") {
      resolve(null);
      return;
    }
    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }
    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }
    try {
      var script = findScript2();
      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript2(params);
      }
      script.addEventListener("load", function() {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error("Stripe.js not available"));
        }
      });
      script.addEventListener("error", function() {
        reject(new Error("Failed to load Stripe.js"));
      });
    } catch (error2) {
      reject(error2);
      return;
    }
  });
  return stripePromise;
};
var stripePromise$1 = Promise.resolve().then(function() {
  return loadScript2(null);
});
stripePromise$1["catch"](function(err) {
  {
    console.warn(err);
  }
});
const stripe_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  CreditCardElements,
  CvvElement,
  DigitalWallets,
  SingleLineCardElement,
  initializeOloPay
};
